@if (vm(); as vm) {
  @if (vm.offerList?.offers?.length > 0) {
    @for (offer of vm.offerList.offers; track offer.offerId; let index = $index) {
      <app-offer
        id="offer-{{ offer.offerId }}"
        [offer]="offer"
        [baseurl]="baseurl"
        [user]="vm.user"
        [index]="index + 1"
        [total]="vm.offerList.offers.length"
        (offerAccepted)="onOfferAccepted($event)"
      />
    }
  } @else {
    <div class="offer-empty">
      {{ 'myOffers.emptyState.list' | cxTranslate }}
    </div>
  }
}
